import React from "react";
import { legalLinks, offer } from "../data/offer";
export function SiteFooter() {
  const year = new Date().getFullYear();
  return <footer className="bg-navy-deep text-white/70" data-id="element-258" data-mp="3r9kjvg3u2fb8">
      <div className="mx-auto max-w-6xl px-5 py-10 text-center" data-id="element-259" data-mp="3mh9h85hpkfez">
        <p className="font-display font-bold text-white" data-id="element-260" data-mp="3mfg90lrg5n4v">
          {offer.productName} — {offer.productSubtitle}
        </p>
        <p className="mt-1 text-sm" data-id="element-261" data-mp="3dguur2t0cu9w">Digital Christian educational resources for families.</p>

        <nav aria-label="Legal" className="mt-6" data-id="element-262" data-mp="38hrmzaln89y8">
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" data-id="element-263" data-mp="38gyr54o834uv">
            {legalLinks.map(link => {
            const href = link.href || (link.label === "Contact Us" && offer.supportEmail ? `mailto:${offer.supportEmail}` : "");
            return <li key={link.label} data-id="element-264" data-mp="11r1z4bvxdf4v">
                  {href ? <a href={href} className="underline-offset-4 transition-colors duration-150 hover:text-white hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold" data-id="element-265" data-mp="11q0k5wbsg8hv">
                      {link.label}
                    </a> : <span data-id="element-266" data-mp="1apygct8lt5re">{link.label}</span>}
                </li>;
          })}
          </ul>
        </nav>

        <p className="mx-auto mt-6 max-w-2xl text-xs leading-relaxed text-white/50" data-id="element-267" data-mp="vspbcwqdo3h7">
          © {year} {offer.productName}. All rights reserved. This site is not affiliated with Facebook, Instagram, or
          Meta. This is a digital product; no physical items will be shipped.
        </p>
      </div>
    </footer>;
}